module.exports = __webpack_public_path__ + "static/img/bookcover.9abb62de.png";